import { useState, useEffect } from 'react';
import FormGroup from '@mui/material/FormGroup';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { formatPhoneNumber } from '@repo/ui/src/components/Form/PhoneInput';
import FormHelpText from './form-helpText';
const FormInput = ({ item, unique, submitted }) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  const isPhone = item.format === 'tel';

  const validate = (val) => {
    if (item.required && val === '') {
      setError(true);
    } else if (item.validation) {
      const regex = new RegExp(item.validation);
      if (!regex.test(val)) {
        setError(true);
      }
    } else {
      setError(false);
    }
  };

  useEffect(() => {
    if (submitted) {
      validate(value);
    }
  });

  return (
    <>
      <FormGroup className="tw-py-4">
        <InputLabel className="tw-font-normal tw-text-[#42474a] tw-pb-2 tra-text-web-body-m">{`${
          item.title
        }${item.required ? ' *' : ''}`}</InputLabel>
        <TextField
          type="text"
          value={value}
          variant="outlined"
          fullWidth
          onBlur={(e) => validate(e.target.value)}
          onChange={(e) =>
            isPhone ? setValue(formatPhoneNumber(e.target.value)) : setValue(e.target.value)
          }
          id={`form-${unique}`}
          inputProps={{
            title: `${item.title}${item.required ? ' *' : ''}`,
          }}
          name={unique}
          title={unique}
          required={item.required}
          aria-required={item.required ? 'true' : 'false'}
          aria-describedby={`${unique}-help`}
          error={error}
          helperText={
            error
              ? item.validationMessage
                ? item.validationMessage
                : `${item.title} is required`
              : ''
          }
          FormHelperTextProps={{
            className: 'tw-mt-1',
          }}
          InputProps={{
            style: {
              backgroundColor: '#ffffff',
              boxShadow: error ? `0px 0px 0px 3px rgba(209, 26, 10, 0.4)` : '',
              '&.Mui-focused': {
                boxShadow: error
                  ? `0px 0px 0px 3px rgba(209, 26, 10, 0.4)`
                  : '0px 0px 0px 3px rgba(217, 94, 22, 0.4)',
              },
              '&.MuiOutlinedInput-notchedOutline': {
                borderColor: '#ecedee',
              },
            },
            endAdornment: (
              <InputAdornment position="end">
                {error ? (
                  <CancelIcon color="error" />
                ) : value === '' ? (
                  ''
                ) : (
                  <CheckCircleIcon color="primary" />
                )}
              </InputAdornment>
            ),
          }}
        />
        <FormHelpText
          display={!!item.helpText}
          unique={unique}
          content={item.helpText !== undefined ? item.helpText : ''}
        />{' '}
      </FormGroup>
    </>
  );
};

export default FormInput;
